import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { StyledTabs } from 'components/TabsPaneStyles'

export const NavWrapper = styled(Flex)`
  padding-bottom: 50px;
`
export const TableTop = styled(Flex)`
  padding: 5px 20px 0px 20px;
  border-top: 1px solid ${COLORS.GREY_T_90};
`

export const StyledP = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.GREY_T_100};
  ${props => props.textType && `text-transform: ${props.textType};`}
  span {
    text-transform: capitalize;
  }
`
export const ModeText = styled(StyledP)`
  text-transform: capitalize;
`
export const StyledDiv = styled.div`
  font-weight: 400;
  font-size: 14px;
`
export const StyledTab = styled(StyledTabs)`
  .ant-tabs-content {
    height: 290px !important;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`
export const SubmitFlex = styled(Flex)`
  gap: 20px;
  padding: 20px;
  border-top: 1px solid ${COLORS.GREY_T_90};
`
export const MenuFlex = styled(Flex)`
  background: ${COLORS.WHITE};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
`
export const CalenderWrap = styled.div`
  padding: 1rem 1rem 1rem 0;
`

export const TableTopForEvaluation = styled(Flex)`
  padding: 5px 20px 0px 20px;
  border-top: 1px solid ${COLORS.GREY_T_90};
  display: flex;
  justify-content: end;
`
